<script lang="ts">
	import { serializeSchema } from '$lib/js/structured_data';

	export let schema: Record<string, any>;
</script>

<svelte:head>
	{@html serializeSchema(schema)}
</svelte:head>
